export const environment = {
  production: true,
  staging: false,
  apiUrl: 'https://dashboard.taptimize.com/api',
  appName: 'Taptimize MK2',
  version: '1.0.0',
  featureFlags: {
    domainTopics: false,
    crawlManagement: false,
    keywordResearch: false,
    competitorFinder: false,
    topicDiagnostic: false,
    csvUpload: false,
    cannibalBacklinksPreviewHighlight: false,
    actionPlanV2: true,
    setup: false,
    clusters: false,
  },
}; 